import LoadingSpinner from "../loading-spinner";
import "./page-loading.css";
export default function PageLoading() {
  return <div className="page-loading" role="status" aria-label="Загрузка страницы"><LoadingSpinner /></div>;
}
